"use strict";

import Dom from "common/Dom";
import * as handlers from "./handlers";
export const bindActions = function bindActions() {
  $(Dom.blogSort).on("change", function (event) {
    var sortQuery = this.value;
    handlers.sortBy(sortQuery);
  });
};
